import type { TasDispatch } from './tas-dispatch.type.ts';

/** Number of unique authorizers required before a dispatch can be disbursed */
const REQUIRED_AUTHORIZATIONS = 2;
export interface TasDispatchExtension extends TasDispatch {}
export class TasDispatchExtension {
  get isCreated() {
    return this.state === 'CREATED';
  }

  get isAuthorized() {
    return this.state === 'AUTHORIZED';
  }

  get isDisbursing() {
    return this.state === 'DISBURSING';
  }

  get isDisbursed() {
    return this.state === 'DISBURSED';
  }

  get isCanceled() {
    return this.state === 'CANCELED';
  }

  get authorizationProgress() {
    return `${this.authorizationCount}/${REQUIRED_AUTHORIZATIONS}`;
  }

  get needsSecondAuthorizer() {
    return this.authorizationCount === REQUIRED_AUTHORIZATIONS - 1;
  }

  get fullyAuthorized() {
    return this.authorizationCount >= REQUIRED_AUTHORIZATIONS;
  }
}

const Registration = {
  kind: 'object',
  name: 'tas-dispatch',
  features: TasDispatchExtension,
};
export default Registration;
